import { defineMessages } from "../i18n/core";

export const usageMessages = defineMessages({
  "pt-BR": {
    title: "Uso e plano",
    lede: (plan: string, start: string, end: string) => `Plano ${plan}. Período de ${start} a ${end}. Máquinas ilimitadas.`,
    protectedTitle: "Espaço ocupado",
    protectedSub: "Guardado no armazenamento depois da deduplicação; é o que conta na franquia e na fatura",
    ofQuota: (quota: string, share: string) => `de ${quota} · ${share} da franquia`,
    noLimit: "sem limite de franquia",
    available: "disponível na franquia",
    protectedAtSource: "protegidos na origem (informativo)",
    storedNote: "O ocupado inclui dados de pontos já apagados até a próxima manutenção do repositório recolhê-los.",
    savings: "economia de espaço",
    overageCharge: "Ao passar da franquia, o excedente é cobrado por GB no fechamento do mês. Backups e restaurações continuam normalmente.",
    overageBlock: "Ao atingir a franquia, novos backups param até ampliar o plano. Restaurações nunca são bloqueadas.",
    gbDefinition: (bytes: string) => `1 GB = ${bytes} bytes.`,
    last30: "Últimos 30 dias",
    topMachines: "Maiores máquinas",
    topMachinesSub: "Dados protegidos por máquina",
    colMachine: "Máquina",
    colProtected: "Protegido",
    colShare: "Participação",
    chart: {
      legendProtected: "Dados protegidos (origem)",
      legendStored: "Ocupado (franquia)",
      legendQuota: "Franquia do plano",
      summary: (days: number, today: string, quota: string) => `Espaço ocupado nos últimos ${days} dias. Hoje ${today} de ${quota} da franquia.`,
      quotaLabel: (quota: string) => `Franquia ${quota}`,
      tipProtected: "Protegido",
      tipStored: "Armazenado",
    },
  },
  "en-US": {
    title: "Usage and plan",
    lede: (plan: string, start: string, end: string) => `${plan} plan. Period from ${start} to ${end}. Unlimited machines.`,
    protectedTitle: "Used space",
    protectedSub: "Stored after deduplication; this is what counts toward the quota and the invoice",
    ofQuota: (quota: string, share: string) => `of ${quota} · ${share} of quota`,
    noLimit: "no quota limit",
    available: "available in quota",
    protectedAtSource: "protected at the source (informational)",
    storedNote: "Used space includes data from deleted restore points until the next repository maintenance collects it.",
    savings: "space savings",
    overageCharge: "Past the quota, the excess is billed per GB at month end. Backups and restores continue normally.",
    overageBlock: "When the quota is reached, new backups stop until the plan is upgraded. Restores are never blocked.",
    gbDefinition: (bytes: string) => `1 GB = ${bytes} bytes.`,
    last30: "Last 30 days",
    topMachines: "Largest machines",
    topMachinesSub: "Protected data per machine",
    colMachine: "Machine",
    colProtected: "Protected",
    colShare: "Share",
    chart: {
      legendProtected: "Protected data (source)",
      legendStored: "Used (quota)",
      legendQuota: "Plan quota",
      summary: (days: number, today: string, quota: string) => `Used space over the last ${days} days. Today ${today} of a ${quota} quota.`,
      quotaLabel: (quota: string) => `Quota ${quota}`,
      tipProtected: "Protected",
      tipStored: "Stored",
    },
  },
  es: {
    title: "Uso y plan",
    lede: (plan: string, start: string, end: string) => `Plan ${plan}. Período del ${start} al ${end}. Equipos ilimitados.`,
    protectedTitle: "Espacio ocupado",
    protectedSub: "Guardado en el almacenamiento tras la deduplicación; es lo que cuenta en la cuota y en la factura",
    ofQuota: (quota: string, share: string) => `de ${quota} · ${share} de la cuota`,
    noLimit: "sin límite de cuota",
    available: "disponible en la cuota",
    protectedAtSource: "protegidos en origen (informativo)",
    storedNote: "Lo ocupado incluye datos de puntos ya borrados hasta que el siguiente mantenimiento del repositorio los recoja.",
    savings: "ahorro de espacio",
    overageCharge: "Al superar la cuota, el excedente se cobra por GB al cierre del mes. Las copias de seguridad y las restauraciones siguen con normalidad.",
    overageBlock: "Al alcanzar la cuota, las nuevas copias de seguridad se detienen hasta ampliar el plan. Las restauraciones nunca se bloquean.",
    gbDefinition: (bytes: string) => `1 GB = ${bytes} bytes.`,
    last30: "Últimos 30 días",
    topMachines: "Equipos más grandes",
    topMachinesSub: "Datos protegidos por equipo",
    colMachine: "Equipo",
    colProtected: "Protegido",
    colShare: "Participación",
    chart: {
      legendProtected: "Datos protegidos (origen)",
      legendStored: "Ocupado (cuota)",
      legendQuota: "Cuota del plan",
      summary: (days: number, today: string, quota: string) => `Espacio ocupado en los últimos ${days} días. Hoy ${today} de una cuota de ${quota}.`,
      quotaLabel: (quota: string) => `Cuota ${quota}`,
      tipProtected: "Protegido",
      tipStored: "Almacenado",
    },
  },
});
